import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Input, Form, DatePicker } from "antd";
import IntlCurrencyInput from "react-intl-currency-input";
import './style.css';
import paymentService from "../../service/payment.service";
import DialogDeConfirmação from "../dialog-confirm/dialogDeConfirmação";
import moment from "moment";
import driverService from "../../service/driver.service";
import freightService from "../../service/freight.service";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PaymentModal = ({ view, visible, onClose, driverName, dataHistory, type, onUpdate }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [dataHistoryy, setDataHistory] = useState('');
  const user = useSelector(state => state.user);

  const [record, setRecord] = useState('');

  const [idFreight, setIdFreight] = useState('');
  const [idDriver, setIdDriver] = useState('');
  const [driverRecord, setDriverRecord] = useState([]);
  const [freightRecord, setFreightRecord] = useState([]);
  const [bankRecord, setBankRecord] = useState({});

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogErro, setOpenDialogErro] = React.useState(false);
  const [erroMessage, setErroMessage] = React.useState("");
  const [message, setMessage] = React.useState("");

  const [formDisabled, setFormDisabled] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [btnLoading, setBtnLoading] = useState(false);
  const previousStatusRef = useRef(null);

  const currencyConfig = {
      locale: "pt-BR",
      formats: {
          number: {
              BRL: {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              },
          },
      },
  };

  const toAmount = (value) => {
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (value == null) return 0;

    const raw = String(value).trim();
    if (!raw) return 0;

    const cleaned = raw.replace(/[^\d,.-]/g, "");
    const normalized =
      cleaned.includes(",") && cleaned.includes(".")
        ? cleaned.replace(/\./g, "").replace(",", ".")
        : cleaned.replace(",", ".");

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const shouldRequireObsUpdate = ({
    valorAdicionalOriginal,
    descontoOriginal,
    valorAdicionalAtual,
    descontoAtual,
  }) => {
    const valorAdicionalAlteradoComValor =
      valorAdicionalOriginal !== valorAdicionalAtual && valorAdicionalAtual > 0;
    const descontoAlteradoComValor =
      descontoOriginal !== descontoAtual && descontoAtual > 0;

    return valorAdicionalAlteradoComValor || descontoAlteradoComValor;
  };

  useEffect(() => {
    setDataHistory(dataHistory);
  }, [dataHistory]);

  useEffect(() => {
    if (driverName) {
      setRecord(driverName);
    }
  }, [driverName, dataHistory]);
  
  useEffect(() => {
    if (record) {
      // Verifica se 'record' contém 'idFreight', senão tenta pegar de 'driverName'
      setIdFreight(record?.idFreight || driverName?.idFreight || null);
      setIdDriver(driverName?.driverID || null);
    }
  }, [record, driverName]);
      const timestamp = moment(dataHistoryy?.initialDate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDate?.nanoseconds / 1_000_000));
      const timestamp2 = moment(dataHistoryy?.initialDateContrate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDateContrate?.nanoseconds / 1_000_000));
      // const timestamp3 = moment(dataHistoryy.initialDate.seconds * 1000 + Math.floor(dataHistoryy.initialDate.nanoseconds / 1_000_000));

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        dataEmissao: record.dataEmissao ? moment(record.dataEmissao, "DD/MM/YYYY") : null,
        status: record.status || undefined,
        obs: record.obs || "",
        valorAdicional: record.valorAdicional || 0,
        desconto: record.desconto || 0,
        solicitante: record.solicitante || "",
      });

      if (!user?.permissoes?.payment?.isEdit && !user?.permissoes?.payment?.editar) {
        const onlyView = true;
        setFormDisabled(onlyView);
        setButtonDisabled(onlyView);
      }
      else {
        const onlyView = false;
        setFormDisabled(onlyView ? onlyView : record.status?.toLowerCase() === 'pago');
        setButtonDisabled(onlyView);
      }
    }
  }, [record, form]);

  const onFinish = async (values) => {

    if (!idFreight) {
      console.error("Erro: ID do frete não foi fornecido!");
      return;
    }

    try {
      const statusAtual = (values?.status || "").toLowerCase();
      if (statusAtual === "pago" && !values?.dataBaixa) {
        form.setFields([
          {
            name: "dataBaixa",
            errors: ["Por favor, selecione a data da baixa para status Pago."],
          },
        ]);
        return;
      }

      const valorAdicionalOriginal = toAmount(record?.valorAdicional ?? 0);
      const descontoOriginal = toAmount(record?.desconto ?? 0);
      const valorAdicionalAtual = toAmount(values?.valorAdicional ?? 0);
      const descontoAtual = toAmount(values?.desconto ?? 0);
      const exigeAtualizarObs = shouldRequireObsUpdate({
        valorAdicionalOriginal,
        descontoOriginal,
        valorAdicionalAtual,
        descontoAtual,
      });
      const obsAtual = (values?.obs || "").trim();
      const obsOriginal = (record?.obs || "").trim();
      const obsFoiAlterada = obsAtual !== obsOriginal;

      if (exigeAtualizarObs && !obsFoiAlterada) {
        form.setFields([
          {
            name: "obs",
            errors: ["Ao alterar valor adicional e/ou desconto, atualize as observações."],
          },
        ]);
        return;
      }

      const formattedDataAtt = values?.dataBaixa ? values.dataBaixa.format("DD/MM/YYYY") : null;
      await paymentService.update({
        idFreight,
        // id: record.id || record?.idFreight + record?.value,
        type: record.type,
        status: values?.status,
        dataEmissao: values?.dataEmissao ? values.dataEmissao.format("DD/MM/YYYY") : (record?.dataEmissao || null),
        obs: values?.obs,
        valueTotal: Number(record.value) + Number(values?.valorAdicional ?? 0) - Number(values?.desconto ?? 0),
        value: record?.value,
        valorAdicional: Number(values?.valorAdicional || 0),
        desconto: Number(values?.desconto || 0),
        dataBaixa: statusAtual === "pago" ? formattedDataAtt : null,
        solicitante: values?.solicitante || "",
      });
      setOpenDialog(true);
      form.resetFields();
    } catch (error) {
      console.error("Erro ao salvar status:", error);
    }
  };

  const handleDialogClose = () => {
    const shouldCloseModal = openDialog;
    setOpenDialog(false);
    setOpenDialogErro(false);

    // Fecha o modal somente após sucesso real da persistência
    if (shouldCloseModal) {
      onUpdate();
      onClose();
    }
  };

  const resetFormToOriginal = () => {
    if (!record) return;
    form.setFieldsValue({
      dataEmissao: record.dataEmissao ? moment(record.dataEmissao, "DD/MM/YYYY") : null,
      status: record.status || undefined,
      obs: record.obs || "",
      valorAdicional: record.valorAdicional || 0,
      desconto: record.desconto || 0,
      solicitante: record.solicitante || "",
      dataBaixa: record?.dataBaixa ? moment(record.dataBaixa, "DD/MM/YYYY") : null,
    });
    if (!user?.permissoes?.payment?.isEdit && !user?.permissoes?.payment?.editar) {
      setFormDisabled(true);
      setButtonDisabled(true);
    } else {
      setFormDisabled(record.status?.toLowerCase() === 'pago');
      setButtonDisabled(false);
    }
  };

  const handleClose = () => {
    resetFormToOriginal();
    onClose();
  };

  const handleGoToDriverEdit = () => {
    if (!idDriver) return;
    navigate(`/driverList/${idDriver}`);
  };

  const valorAdicionalRaw = Form.useWatch('valorAdicional', form);
  const descontoRaw = Form.useWatch('desconto', form);
  const status = Form.useWatch('status', form);
  const valorAdicionall = Number(valorAdicionalRaw) || 0;
  const descontoo = Number(descontoRaw) || 0;  
  const valorTotal = (record?.value || 0) + (valorAdicionall || 0) - (descontoo || 0);

  useEffect(() => {
    previousStatusRef.current = (record?.status || "").toLowerCase() || null;
  }, [record]);

  useEffect(() => {
    let isMounted = true;

    const preloadBankData = async () => {
      if (!visible || !idDriver) {
        setBankRecord({});
        return;
      }

      try {
        const documentsSnapshot = await driverService.getDriverDocuments(idDriver);
        const documents = [];
        documentsSnapshot.forEach((doc) => {
          documents.push({ id: doc.id, ...doc.data() });
        });

        if (isMounted) {
          setBankRecord((documents[0] && documents[0].dataBank) || {});
        }
      } catch (error) {
        console.error("Erro ao carregar dados bancários:", error);
        if (isMounted) {
          setBankRecord({});
        }
      }
    };

    preloadBankData();

    return () => {
      isMounted = false;
    };
  }, [visible, idDriver]);

  useEffect(() => {
    if (!record) return;

    if (!form) return;

    if (record?.dataBaixa) {
      form.setFieldsValue({ dataBaixa: moment(record.dataBaixa, "DD/MM/YYYY") });
    } 
    else {
      form.setFieldsValue({ dataBaixa: null });
    }

    const currentStatus = (status || "").toLowerCase();
    const previousStatus = previousStatusRef.current;

    if (currentStatus === "solicitar pagamento" && previousStatus !== "solicitar pagamento") {
      form.setFieldsValue({
        dataEmissao: moment(),
        solicitante: user?.name || "",
      });
    }
    else {
      form.setFieldsValue({
        dataEmissao: record.dataEmissao ? moment(record.dataEmissao, "DD/MM/YYYY") : null,
        solicitante: record.solicitante || "",
      });
    }

    previousStatusRef.current = currentStatus || null;

  }, [record, status, form, user]);

  const handleSearchInfo = async (idDriver, idFreight) => {
    let driverData = null;
    let freightData = null;
    
    if (!idDriver || !idFreight) {
      console.error("Erro: ID do motorista ou do frete não foi fornecido!");
      return { driverData, freightData };
    }

    try {
      await driverService.getDriverAvailable(idDriver)
        .then( async (doc) => {
          if (doc.exists) {
            driverData = {
              ...doc.data(),
              driver: doc.data().name || "Motorista não encontrado",
              type: type || "Tipo não definido",
              value: dataHistory?.value || 0,
            };

            const documentsSnapshot = await driverService.getDriverDocuments(idDriver);
            const documents = [];
            documentsSnapshot.forEach((doc) => {
              documents.push({ id: doc.id, ...doc.data() });
            });

            driverData.documents = documents;
            setDriverRecord(driverData);
            setBankRecord((documents[0] && documents[0].dataBank) || {});
          } else {
            console.error("Motorista não encontrado");
          }
        });
    }
    catch (error) {
      console.error("Erro ao buscar informações:", error);
    }

    try {
      await freightService.getFreightById(idFreight)
        .then((doc) => {
          if (doc.exists) {
            freightData = { ...doc.data() };
            setFreightRecord(freightData);
          } else {
            console.error("Frete não encontrado");
          }
        });
    }
    catch (error) {
      console.error("Erro ao buscar informações:", error);
    }
    return { driverData, freightData };
  }

  const handleCreateHtml = async (dadoDriver, dataFreight, Subject, obs, valorSolicitado, valorOriginal, valorAdicional, valorDesconto, type, driver) => {
    if (!dadoDriver || !dataFreight) {
      console.error("Erro: Dados insuficientes para criar HTML!");
      return;
    }

    await paymentService.prepareEmail(
        dadoDriver,  
        dataFreight,
        Subject,
        obs,
        valorSolicitado,
        valorOriginal,
        valorAdicional,
        valorDesconto,
        type,
        user,
        driver
      );
  }

  return (
    <>
    <Modal
      title={
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 20, fontWeight: 400 }}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/app-fortio.appspot.com/o/files%2Fwallet-filled-money-tool%201.svg?alt=media&token=0a32098e-e995-41b0-ac88-fafcfbc0e03d"
              alt="icone pagamento"
              width={24}
              height={24}
            />
            <span>Baixa Pagamento</span>
          </div>
          <div style={{ fontSize: 16, color: "rgba(0, 0, 0, 0.45)", marginLeft: "34px" }}>Informação do Frete</div>
        </div>
      }
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Cancelar
        </Button>,
        <Button key="edit-driver" onClick={handleGoToDriverEdit} disabled={!idDriver}>
          Alterar Dados
        </Button>,
        <Button disabled={buttonDisabled} type="primary" loading={btnLoading} onClick={async () => {
          if (formDisabled) {
            // Reativa os campos
            setFormDisabled(false);
            return;
          }

          try {
            // 1. Validações de valores alterados
            const valorAdicionalOriginal = toAmount(record?.valorAdicional ?? 0);
            const descontoOriginal = toAmount(record?.desconto ?? 0);
            const valorAdicionalAtual = toAmount(form.getFieldValue('valorAdicional') ?? 0);
            const descontoAtual = toAmount(form.getFieldValue('desconto') ?? 0);
            const exigeAtualizarObs = shouldRequireObsUpdate({
              valorAdicionalOriginal,
              descontoOriginal,
              valorAdicionalAtual,
              descontoAtual,
            });
            const houveMudancaValores =
              valorAdicionalOriginal !== valorAdicionalAtual ||
              descontoOriginal !== descontoAtual;

            const obsAtual = (form.getFieldValue('obs') || '').trim();
            const obsOriginal = (record?.obs || '').trim();
            const obsFoiAlterada = obsAtual !== obsOriginal;

            if (exigeAtualizarObs && !obsFoiAlterada) {
              form.setFields([
                {
                  name: 'obs',
                  errors: ['Ao alterar valor adicional e/ou desconto, atualize as observações.'],
                },
              ]);
              setOpenDialogErro(true);
              setErroMessage("Erro no formulário!");
              setMessage(<>Ao alterar <b>valor adicional</b> e/ou <b>desconto</b>, você deve também <b>atualizar as Observações</b>.</>);
              return;
            }

            // 2. Valida status
            const statusAtual = form.getFieldValue('status');
            if (!statusAtual || statusAtual === "") {
              setOpenDialogErro(true);
              setErroMessage("Erro no formulário!");
              setMessage(<>Por favor, selecione um <b>status</b> válido.</>);
              return;
            }
            const statusAtualNormalizado = (statusAtual || "").toLowerCase();
            const dataBaixaAtual = form.getFieldValue('dataBaixa');
            if (statusAtualNormalizado === "pago" && !dataBaixaAtual) {
              form.setFields([
                {
                  name: "dataBaixa",
                  errors: ["Por favor, selecione a data da baixa para status Pago."],
                },
              ]);
              setOpenDialogErro(true);
              setErroMessage("Erro no formulário!");
              setMessage(<>Para o status <b>Pago</b>, o campo <b>Data da Baixa</b> é obrigatório.</>);
              return;
            }

            await form.validateFields();

            // 3. Envio de email (se necessário)
            let emailEnviadoComSucesso = true;
            const statusAnterior = record?.status?.toLowerCase();

            if (statusAtualNormalizado === 'solicitar pagamento') {
              setBtnLoading(true);

              try {
                const { driverData, freightData } = await handleSearchInfo(idDriver, idFreight);

                if (!driverData || !freightData) {
                  throw new Error("Dados do motorista ou frete não encontrados");
                }

                // Determina se é Errata ou Solicitação normal
                // Errata: se JÁ estava em "solicitar pagamento" E houve mudança de valores
                const isErrata = statusAnterior === 'solicitar pagamento' && (houveMudancaValores || obsFoiAlterada);
                const assunto = isErrata ? "Errata! Solicitação de Pagamento" : "Solicitação de Pagamento";

                await handleCreateHtml(
                  driverData,
                  freightData,
                  assunto,
                  obsAtual || record.obs,
                  valorTotal,
                  record?.value,
                  valorAdicionalAtual,
                  descontoAtual,
                  record.type,
                  record.driver
                );
              } catch (emailError) {
                console.error("Erro no envio do e-mail:", emailError);
                emailEnviadoComSucesso = false;
                form.setFieldsValue({ status: record?.status ?? undefined });
                setOpenDialogErro(true);
                setErroMessage("Erro no envio do e-mail");
                setMessage(<>Não foi possível enviar o e-mail de solicitação de pagamento. O status foi revertido para <b>{record?.status || "anterior"}</b>. Tente novamente.</>);
              } finally {
                setBtnLoading(false);
              }
            }

            // 4. Só submete se o email foi enviado com sucesso (ou se não era necessário enviar email)
            if (emailEnviadoComSucesso) {
              form.submit();
            }
          } catch (errorInfo) {
            console.error("Erro de validação:", errorInfo);
            setBtnLoading(false);
          }
        }}>
          {formDisabled ? buttonDisabled ? "Salvar" : "Desfazer Baixa" : "Salvar"}
        </Button>,
      ]}
      width={700}
    >
      <Form form={form} onFinish={onFinish} style={{ paddingLeft: '4%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', border: 'none', cursor: 'default' }}>

        <div className="formMotoType">
          <div className="formMotorista" >
            <div> <p>Motorista: </p> </div>
            <Form.Item /* label="Motorista" */ >
              <input className="form-control my-0" value={record?.driver ?? "Erro na busca do Motorista"} disabled />
            </Form.Item>
          </div>

          <div className="tipoType">
            <div> <p>Tipo: </p> </div>
            <Form.Item /* label="Tipo" */ style={{ width: '207px' }} disabled>
              <input className="form-control my-0" placeholder={record.type} disabled />
            </Form.Item>
          </div>

          <div className="formStatus" >
            <div> <p>Status:</p> </div>
            <Form.Item /* label="Status" */ name="status" >
              <select disabled={formDisabled} className="form-select" >
                <option value="">Selecione o Status</option>
                <option value="bloqueado">Bloqueado</option>
                <option value="pendente">Pendente Liberação</option>
                <option value="solicitar pagamento">Solicitar Pagamento</option>
                <option value="pago">Pago</option>
                <option value="cancelado">Cancelado</option>
              </select>
            </Form.Item>
          </div>
        </div>

        <div className="formDescVencimento" >
          <div className="formTitularConta">
            <div> <p>Titular da Conta: </p> </div>
            <Form.Item>
              <Input
                className="form-control my-0"
                value={bankRecord?.holderAccount || ""}
                readOnly
                disabled
              />
            </Form.Item>
          </div>

          <div className="formChavePix">
            <div> <p>Chave pix: </p> </div>
            <Form.Item>
              <Input
                className="form-control my-0"
                value={bankRecord?.pix || ""}
                readOnly
                disabled
              />
            </Form.Item>
          </div>

          <div className="formSolicitante">
            <div> <p>Solicitante: </p> </div>
            <Form.Item name="solicitante" >
              <Input className="form-control my-0" disabled />
            </Form.Item>
          </div>
        </div>

        <div className="formValOriStatus" >
          <div className="valorOriginal">
            <div> <p>Valor Original:</p> </div>
            <Form.Item /* label="Valor Original" */ name="valorOriginal" >
              <IntlCurrencyInput
                id="InputDinero"
                currency="BRL"
                config={currencyConfig}
                defaultValue={record?.value ?? 0}
                className="form-control my-0"
                disabled
              />
            </Form.Item>
          </div>

          <div>
            <div> <p>Valor Adicional: </p> </div>
            <Form.Item /* label="Valor Adicional" */ name="valorAdicional">
              <IntlCurrencyInput
                disabled={formDisabled}
                id="InputDinero"
                currency="BRL"
                config={currencyConfig}
                value={form.getFieldValue('valorAdicional') ?? 0}
                className="form-control my-0"
                onChange={(event, value, maskedValue) => {
                  form.setFieldsValue({ valorAdicional: value });
                }}
              />
            </Form.Item>
          </div>

          <div>
            <div>
              <p>Desconto: </p>
            </div>
            <Form.Item /* label="Desconto" */ name="desconto">
              <IntlCurrencyInput
                disabled={formDisabled}
                id="InputDinero"
                currency="BRL"
                config={currencyConfig}
                value={form.getFieldValue('desconto') ?? 0}
                className="form-control my-0"
                onChange={(event, value, maskedValue) => {
                  form.setFieldsValue({ desconto: value });
                }}
              />
            </Form.Item>
          </div>
        </div>

        <div className="valorDataBaixa">
          <div className="formDataAtt">
            <div> <p>Data de Solicitação: </p> </div>
            <Form.Item name="dataEmissao" >
              <DatePicker placement="bottomRight" format="DD/MM/YYYY" style={{ width: '100%' }} disabled />
            </Form.Item>
          </div>

          <div className="formDataBaixa">
            <div> <p>Data da Baixa: </p> </div>
            <Form.Item
              name="dataBaixa"
              rules={[
                {
                  validator: (_, value) => {
                    const currentStatus = form.getFieldValue('status');
                    if ((currentStatus || '').toLowerCase() === 'pago') {
                      return value ? Promise.resolve() : Promise.reject(new Error("Por favor, selecione a data"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker placement="bottomRight" format="DD/MM/YYYY" style={{ width: '208px' }} disabled={(status || "").toLowerCase() !== "pago" || formDisabled} getPopupContainer={trigger => trigger.parentNode} dropdownClassName="custom-date-picker-popup" />
            </Form.Item>
          </div>

          <div>
            <div> <p>Total: </p> </div>
            <Form.Item /* label="Valor" */>
              {/* <input style={{ width: "208px" }} className="form-control my-0" placeholder={ Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL' }).format(valorTotal) } disabled /> */}
              <span style={{ width: "208px", fontSize: 20, fontWeight: 600, color: "rgba(0, 0, 0, 0.85)" }}>
                {Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL' }).format(valorTotal)}
              </span>
            </Form.Item>
          </div>
        </div>

        <div className="tipoObs2">
          <div> <p>Observações: </p> </div>
          <Form.Item name="obs" >
            {/* <Input className="InputTypeText" type="text" placeholder="Digite sua Observação" /> */}
            <Input.TextArea disabled={formDisabled} className="InputTypeText" placeholder={"Digite sua Observação"} style={{ width: '100%' }} />
          </Form.Item>
        </div>
      </Form>
    </Modal>

    <DialogDeConfirmação
      open={openDialog}
      handleClose={handleDialogClose}
      title="Confirmado!"
      message="O pagamento foi solicitado com sucesso."
      status="success"
    />
    <DialogDeConfirmação
      open={openDialogErro}
      handleClose={handleDialogClose}
      title={erroMessage}
      message={message}
      status="error"
    />
    </>
  );
};

export default PaymentModal;
